module.exports = require("./shi.d.ts");